import { render } from "./_.vue?vue&type=template&id=54d7e424"
import script from "./_.vue?vue&type=script&lang=js"
export * from "./_.vue?vue&type=script&lang=js"

import exportComponent from "/Users/jeongyunl/Documents/GitHub/datamap-search/vue-for-django/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__